import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { toast } from 'react-toastify';
import globalSettingsBranches from '../../../../stores/global-settings-branches';
import { addNewBuildingOperations } from './operations/add-new-building-operations';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import { updateEntityNameOperation } from '../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../operations/update-entity-name/settings-entity-types';
import { EditTextDialog } from '../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { Building } from '../../../../api/types/settings/buildings/building';
import { deleteBuildingIdOperations } from './operations/delete-building-id-operations';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

export const SettingsBuildingsList: React.FC = observer(() => {
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [newBuildingName, setNewBuildingName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAddBuilding = async () => {
    if (!newBuildingName.trim()) {
      toast.warn('Please enter a building name');
      return;
    }
    await addNewBuildingOperations(newBuildingName, () => setShowDialog(false));
  };

  const [editBranch, setEditBranch] = useState<Building | null>(null);

  const handleEditBuildingOn = async (building: Building) => {
    setEditBranch(building);
  };

  const handleEditBuilding = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.BUILDING,
      id,
      newName,
      setIsLoading,
    );
  };

  const [deleteBuildingId, setDeleteBuildingId] = useState<number | null>(null);

  const handleDeleteBuilding = async (buildingId: number) => {
    await deleteBuildingIdOperations(buildingId, setDeleteBuildingId);
  };

  const handleBuildingClick = (building: Building) => {
    navigate(`/settings/buildings/${building.id}/classes`);
  };

  return (
    <div className="card">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '4px',
        }}
      >
        <h2>מבנים וכיתות</h2>
        <Button
          style={{ height: '35px', width: '35px' }}
          icon="pi pi-plus"
          tooltip={'הוספת מבנה'}
          onClick={() => setShowDialog(true)}
        />
      </div>

      <DataTable
        value={globalSettingsBranches.buildings}
        rows={10}
        emptyMessage="לא נמצאו נתונים"
        onRowClick={(e) => handleBuildingClick(e.data as Building)}
        className="cursor-pointer"
      >
        <Column
          field="buildingName"
          header="שם המבנה"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="createdByName"
          header="נוצר ע״י"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="createdAt"
          header="נוצר ב"
          sortable
          body={(rowData) => new Date(rowData.createdAt).toLocaleDateString()}
          style={{ textAlign: 'right' }}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: Building) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת מבנה'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditBuildingOn(data);
                }}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת מבנה'}
                loading={deleteBuildingId === data.id}
                disabled={deleteBuildingId !== null}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteBuilding(data.id);
                }}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        header="הוספת מבנה"
        modal
        style={{ width: '400px' }}
      >
        <div className="flex flex-column gap-3">
          <EditText
            title={'שם המבנה'}
            value={newBuildingName}
            onChange={(str) => setNewBuildingName(str)}
          />

          <div className="flex justify-content-end gap-2">
            <Button
              label="ביטול"
              onClick={() => setShowDialog(false)}
              className="p-button-text"
            />
            <Button
              label="אישור"
              onClick={handleAddBuilding}
              loading={isLoading}
            />
          </div>
        </div>
      </Dialog>

      <EditTextDialog
        id={editBranch?.id}
        value={editBranch?.buildingName}
        title="עריכת שלוחה"
        label="שם השלוחה"
        loading={isLoading}
        onSave={handleEditBuilding}
        onHide={() => setEditBranch(null)}
      />
    </div>
  );
});
